import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiBkSearchTask extends apiCommonCategory{
  static module = "bk_search_task";

  static async getInfo(){
    return post('/home/bk_search_task/getInfo')
  }

  static async save(data){
    return post('/home/bk_search_task/save', data)
  }

  static async listDel(ids) {
    return post('/home/bk_search_task/listDel', { ids })
  }

  static async downMarc(id){
    return post('/home/bk_search_task/downMarc', { id })
  }

  static async downloadSuccessItems(id){
    return post('/home/bk_search_task/downloadSuccessItems', { id })
  }

  static async createFromOrder(orderId){
    return post('/home/bk_search_task/createFromOrder', { orderId })
  }
}
